import { render, staticRenderFns } from "./ChatContextBar.vue?vue&type=template&id=4d34ea8f&scoped=true&"
import script from "./ChatContextBar.vue?vue&type=script&lang=js&"
export * from "./ChatContextBar.vue?vue&type=script&lang=js&"
import style0 from "./ChatContextBar.vue?vue&type=style&index=0&id=4d34ea8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34ea8f",
  null
  
)

export default component.exports